import { styled } from 'linaria/react';
/**
 * Object root
 */

export const Root = /*#__PURE__*/styled("div")({
  name: "Root",
  class: "rph8zxp"
});
/**
 * Table
 */

export const Table = /*#__PURE__*/styled("span")({
  name: "Table",
  class: "t74qmsr"
});
/**
 * HTML
 */

export const HTML = /*#__PURE__*/styled("span")({
  name: "HTML",
  class: "h18pkd65"
});
/**
 * Object constructor
 */

export const Constructor = /*#__PURE__*/styled("span")({
  name: "Constructor",
  class: "c1bj3xha"
});